// extracted by mini-css-extract-plugin
export default {"container":"QuickCaseOpen_container__xZ1A9","filter":"QuickCaseOpen_filter__GUhvB","input":"QuickCaseOpen_input__-1Tiu","btn":"QuickCaseOpen_btn__6-ABI"};